import { cn } from '@/lib/utils'

type FeatureToggleProps = {
  label: string
  description?: string
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

export function FeatureToggle({ label, description, checked, onChange, disabled }: FeatureToggleProps) {
  return (
    <label
      className={cn(
        'flex cursor-pointer items-start gap-3 rounded-2xl border border-border bg-muted/40 p-4 shadow-sm transition-all hover:border-border hover:bg-muted/60 has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-60',
      )}
    >
      <input
        type="checkbox"
        className="mt-1 h-4 w-4 rounded border-border text-primary focus:ring-ring/30"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span>
        <span className="block text-sm font-medium text-foreground">{label}</span>
        {description ? (
          <span className="mt-0.5 block text-xs text-muted-foreground">{description}</span>
        ) : null}
      </span>
    </label>
  )
}
